import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
// 安全地从localStorage获取用户数据
const getUserFromStorage = () => {
  try {
    const userData = localStorage.getItem('user');
    if (!userData || userData === 'undefined' || userData === 'null') {
      return {};
    }
    return JSON.parse(userData);
  } catch (error) {
    console.error('解析用户数据失败:', error);
    localStorage.removeItem('user'); // 清除损坏的数据
    return {};
  }
};

const store = new Vuex.Store({
  state: {
    user: getUserFromStorage(),
    token: localStorage.getItem('token') || '',
    ifCompose: false,// 当前编辑状态
    patient: {},
    systemInfo: {},
    system: '', // 用户端 or 管理端
  },

  mutations: {
    updateUser(state, data) {
      state.user = data;
      localStorage.setItem('user', JSON.stringify(data));
    },
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    updateIfCompose(state, ifCompose) {
      state.ifCompose = ifCompose;
    },
    updatePatient(state, data) {
      state.patient = data;
    },
    updateSystemInfo(state, data) {
      state.systemInfo = data;
    },
    updateSystem(state, data) {
      state.system = data;
    },
  }
});

export default store;
